import { render, staticRenderFns } from "./KeyboardEvents.vue?vue&type=template&id=c25358f0"
import script from "./KeyboardEvents.vue?vue&type=script&lang=js"
export * from "./KeyboardEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports